import { render, staticRenderFns } from "./ContactsPage.vue?vue&type=template&id=3ff731e3&scoped=true&"
import script from "./ContactsPage.vue?vue&type=script&lang=js&"
export * from "./ContactsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff731e3",
  null
  
)

export default component.exports